import React, { useState, useEffect } from 'react';
import { Field } from 'formik';
import * as moment from 'moment';
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
import { FORMAT, BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import differenceInYears from "date-fns/differenceInYears";
import './form-elements.scss';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

export default ({ name, type, props,placeholderText, selectedDate, editResponse, pickupDays, prePopulateState, leadTimeState, response, recurringDate, deliveryTime, callBackFun, minDate, selectedEditDate, clearDateFlag, disabled, uploadType, userType, editedValuePrefill, max, min, nonDisabledDaysList, ...otherProps }) => {
  let dateSet = new Date();
  let minDOBirth = new Date();
  let maxDOBirth = '';
  let dateArr = []

  if (type === "ReschduleDatesDisabled") {
    if (response && response.defaultProfile && response.defaultProfile.dayOfWeeks.length !== 0) {
      for (let i = 0; i < response.defaultProfile.dayOfWeeks.length; i++) {
        let weekDays = [
          'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
        ];

        let curDate = new Date();
        let to = curDate.setDate(curDate.getDate() + 7);
        for (let j = 0; j < weekDays.length; j++) {
          if (weekDays[j] === response.defaultProfile.dayOfWeeks[i]) {
            let findDate = curDate.setDate(curDate.getDate() + j);
            for (let k = new Date(); k < new Date(to); k.setDate(k.getDate() + 1)) {
              let findDay = new Date(k).getDay()

              if (findDay === 0) {
                findDay = 7
              }
              if (findDay === j + 1) {
                dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
              }
            }
          }

        }
        dateArr = dateArr.sort()
      }
    }
  }

  const [getClearDateFlag, setClearDateFlag] = useState(clearDateFlag);
  const [dateFlag, setDateFlag] = useState(false);
  useEffect(() => {
    setClearDateFlag(clearDateFlag)
    if (name === 'recStartDateTemp' || name === 'recEndDateTemp') {
      onChange(value)
    }
  }, [clearDateFlag]);

  if (name === "bidCloseTime" && type !== 'PostNeed') {
    if (editResponse && editResponse.bidCloseTime) {
      let plusTwo = moment(new Date(editResponse.bidCloseTime).setDate(new Date(editResponse.bidCloseTime).getDate()))
      dateSet = new Date(plusTwo)
    }
  }
  if (name === "checkOutDate") {
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 3);
    dateSet = new Date(plusTwo)
  }
  if (name === "pickUpDate") {
    let plusTwo = moment(new Date().setDate(new Date(response.deliveryDate).getDate() + 2))
    dateSet = new Date(plusTwo)
  }
  if (name === "cancelDate") {
    if (userType === "SELLER") {
      if (response && response.defaultProfile && response.defaultProfile.dayOfWeeks.length !== 0 && type === "ReschduleDatesDisabled") {
        minDOBirth = dateArr[0]
        dateSet = dateArr[0]
      } else {
        let plusTwo = moment(new Date().setDate(new Date(selectedDate).getDate() + 7))
        dateSet = new Date(plusTwo)
      }
    } else {
      let date = new Date(selectedDate);
      let plusTwo = date.setDate(date.getDate());

      if (response && response.defaultProfile && response.defaultProfile.dayOfWeeks.length !== 0 && type === "ReschduleDatesDisabled") {
        minDOBirth = dateArr[0]
        dateSet = dateArr[0]
      } else {
        dateSet = new Date(plusTwo)
      }
    }
  }
  if (name === "endBy") {
    if (selectedDate) {
      dateSet = new Date(selectedDate)
    } else {
      let date = new Date();
      let plusTwo = date.setDate(date.getDate() + 8);
      dateSet = new Date(plusTwo)
    }

    minDOBirth = dateSet;
  }


  if (name === 'dob') {
    let date = new Date();
    let plusTwo = date.setFullYear(date.getFullYear() - 18)
    dateSet = new Date(plusTwo)

    minDOBirth = undefined
    maxDOBirth = new Date()
  } else if (name === 'bidCloseTime') {
    const currentdate = new Date();
    if (name === "bidCloseTime" && editResponse && editResponse.bidCloseTime) {
      minDOBirth = dateSet;
      let date = new Date();
      let plusDay = date.setDate(date.getDate() + 4);
      maxDOBirth = new Date(plusDay);
    }
    else if (name === "bidCloseTime" && !editResponse?.bidCloseTime) {
      let date = new Date();
      let plusDay;
      let plusTwo;
      if(type ==="editPost"){
        minDOBirth = date.setDate(date.getDate()+ 1);
      }else{
        if(props.values.state === 'Alaska'){
          // let tempTime = new Date().toLocaleString('en-US', { timeZone: 'US/' + timeZoneFun(props.values.state) });
          // let getTime = new Date(tempTime)
          // date = new Date(getTime.setDate(new Date(getTime).getDate()))
          let tempTime = moment().tz("US/Alaska") //new Date().toLocaleString('en-US', { timeZone: 'US/' + timeZoneFun(stateZone) });         
          let getTime = new Date(tempTime)
          date = new Date(getTime.setDate(new Date(getTime).getDate()))

        }
        
        minDOBirth = date.setDate(date.getDate());
      }
      
      if (leadTimeState === "24") {
        plusDay = date.setDate(date.getDate() + 1);
        plusTwo = date.setDate(date.getDate() + 3);
      } else if (leadTimeState === "48") {
        plusDay = date.setDate(date.getDate() + 2);
        plusTwo = date.setDate(date.getDate() + 2);
      } else if (leadTimeState === "72") {
        plusDay = date.setDate(date.getDate() + 3);
        plusTwo = date.setDate(date.getDate() + 1);
      } else {
        plusDay = date.setDate(date.getDate() + 4);
        plusTwo = date.setDate(date.getDate());
      }

      if (type !== "PostNeed") {
        dateSet = new Date(plusDay)
      }

      maxDOBirth = new Date(plusTwo);
    }
  } else if (name === 'requestDeliveryDate') {
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 7);
    let currentDate = new Date();
    minDOBirth = currentDate.setDate(currentDate.getDate() + 1);
    maxDOBirth = new Date(plusTwo);
  } else if (name === "checkOutDate") {
    const currentdate = new Date();
    let date = new Date();

    if (response.bidCloseTime) {
      let wkdy = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours())).getDay();
      let caculateDays;
      let plusTwo;
      if (wkdy === 3) {
        if (deliveryTime === 48) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
        else if (deliveryTime === 72) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else {
          if (deliveryTime === 1) {
            caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
          } else {
            caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
          }
        }
      } else if (wkdy === 4) {
        if (deliveryTime === 48) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else if (deliveryTime === 72) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else {
          if (deliveryTime === 1) {
            caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
          } else {
            caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
          }
        }
      } else if (wkdy === 5) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      } else if (wkdy === 6) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      } else if (wkdy === 7) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      } else {
        // if (deliveryTime === 1) {
        //   caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
        //   plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        // } else {
        //   caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
        //   plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        // }
      }
      dateSet = new Date(plusTwo)
      let mindate = new Date(dateSet)

      if (type === "DatesDisabled") {
        if (response?.isDeliveryAvailable) {
          if (prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks && prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks.length !== 0) {
            for (let i = 0; i < prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks.length; i++) {
              let weekDays = [
                'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
              ];

              let curDate = new Date(plusTwo);
              let nextDaysDate = new Date(plusTwo)

              let to = curDate.setDate(curDate.getDate() + 7);
              for (let j = 0; j < weekDays.length; j++) {
                if (weekDays[j] === prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks[i]) {
                  for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                    let findDay = new Date(k).getDay()
                    if (findDay === 0) {
                      findDay = 7
                    }
                    if (findDay === j + 1) {
                      dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                    }
                  }
                }
              }
              dateArr = dateArr.sort()
            }
            dateSet = dateArr[0]
            minDOBirth = dateArr[0]


          } else {
            minDOBirth = dateSet
          }
        } else {
          if (response?.brokerDayOfWeeks && response?.brokerDayOfWeeks?.length !== 0 && !response?.isPostRecurring && !response?.isRecurring) {
            if (response.brokerDayOfWeeks.length !== 0) {
              for (let i = 0; i < response.brokerDayOfWeeks.length; i++) {
                let weekDays = [
                  'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
                ];

                let curDate = new Date(plusTwo);
                let nextDaysDate = new Date(plusTwo)

                let to = curDate.setDate(curDate.getDate() + 7);
                for (let j = 0; j < weekDays.length; j++) {
                  if (weekDays[j] === response.brokerDayOfWeeks[i]) {
                    for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                      let findDay = new Date(k).getDay()
                      if (findDay === 0) {
                        findDay = 7
                      }
                      if (findDay === j + 1) {
                        dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                      }
                    }
                  }
                }
                dateArr = dateArr.sort()
              }
            }
            dateSet = dateArr[0]
            minDOBirth = dateArr[0]
            let maxdate = mindate.setDate(mindate.getDate() + 7);
            maxDOBirth = maxdate;
          } else {
            if (response && response.dayOfWeeks && response.dayOfWeeks.length !== 0) {
              for (let i = 0; i < response.dayOfWeeks.length; i++) {
                let weekDays = [
                  'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
                ];

                let curDate = new Date(plusTwo);
                let nextDaysDate = new Date(plusTwo)

                let to = curDate.setDate(curDate.getDate() + 7);
                for (let j = 0; j < weekDays.length; j++) {
                  if (weekDays[j] === response.dayOfWeeks[i]) {
                    for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                      let findDay = new Date(k).getDay()
                      if (findDay === 0) {
                        findDay = 7
                      }
                      if (findDay === j + 1) {
                        dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                      }
                    }
                  }
                }
                dateArr = dateArr.sort()
              }

              dateSet = dateArr[0]
              minDOBirth = dateArr[0]
            } else {
              minDOBirth = dateSet
            }
          }
        }
      } else {
        minDOBirth = dateSet
        let maxdate = mindate.setDate(mindate.getDate() + 7);
        maxDOBirth = maxdate;
      }
    } else {
      dateSet = dateSet
      minDOBirth = dateSet
      maxDOBirth = currentdate.setDate(currentdate.getDate() + 7);;
    }
  } else if (name === "pickUpDate") {
    let date = new Date();
    let plusSeven = date.setDate(date.getDate() + 7);
    maxDOBirth = new Date(plusSeven)
    if (type === "claimDatesDisabled") {
      if (response && response.order.defaultProfile.dayOfWeeks) {
        if (response.order.defaultProfile.dayOfWeeks.length !== 0) {
          for (let i = 0; i < response.order.defaultProfile.dayOfWeeks.length; i++) {
            let weekDays = [
              'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
            ];

            let curDate = new Date();
            let to = curDate.setDate(curDate.getDate() + 7);
            for (let j = 0; j < weekDays.length; j++) {
              if (weekDays[j] === response.order.defaultProfile.dayOfWeeks[i]) {
                let findDate = curDate.setDate(curDate.getDate() + j);
                for (let k = new Date(); k < new Date(to); k.setDate(k.getDate() + 1)) {
                  let findDay = new Date(k).getDay()

                  if (findDay === 0) {
                    findDay = 7
                  }
                  if (findDay === j + 1) {
                    dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                  }
                }
              }
            }
            dateArr = dateArr.sort()
          }
        }

        dateSet = dateArr[0]
        minDOBirth = dateArr[0]
      } else {
        minDOBirth = new Date();
        dateSet = minDOBirth
      }

    } else {
      minDOBirth = new Date();
      dateSet = minDOBirth
    }

  } else if (name === "endBy") {
    const currentdate = new Date();
    const maxdate = new Date(currentdate.setYear(currentdate.getFullYear() + 1));
    minDOBirth = dateSet
    maxDOBirth = maxdate;
  } else if (name === "deliveryDateCheckout") {
    const currentdate = new Date();
    let date = new Date();
    let wkdy = date.getDay();
    dateArr = []
    if (deliveryTime) {
      let caculateDays;
      let plusTwo;
      if (wkdy === 3) {
        if (deliveryTime === 72) {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else {
          if (deliveryTime === 1) {
            caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
          } else {
            caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
          }
        }
      } else if (wkdy === 4) {
        if (deliveryTime === 48) {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else if (deliveryTime === 72) {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        } else {
          if (deliveryTime === 1) {
            caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
          } else {
            caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
            plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
          }
        }
      } else if (wkdy === 5) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 72))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }

      } else if (wkdy === 6) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      } else if (wkdy === 7) {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 48))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      }
      else {
        if (deliveryTime === 1) {
          caculateDays = new Date(new Date(response.bidCloseTime).setHours(new Date(response.bidCloseTime).getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours()))
        } else {
          caculateDays = new Date(new Date().setHours(new Date().getHours() + 24))
          plusTwo = new Date(new Date(caculateDays).setHours(new Date(caculateDays).getHours() + deliveryTime))
        }
      }

      dateSet = new Date(plusTwo)
      let mindate = new Date(dateSet)
      let getDay = dateSet.getDay();
      if (type === "DatesDisabled") {
        if (response?.isDeliveryAvailable && !pickupDays) {
          if (prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks && prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks.length !== 0) {
            for (let i = 0; i < prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks.length; i++) {
              let weekDays = [
                'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
              ];

              let curDate = new Date(plusTwo);
              let nextDaysDate = new Date(plusTwo)

              let to = curDate.setDate(curDate.getDate() + 7);
              for (let j = 0; j < weekDays.length; j++) {
                if (weekDays[j] === prePopulateState?.payload?.locationDetail?.defaultProfile?.dayOfWeeks[i]) {
                  for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                    let findDay = new Date(k).getDay()
                    if (findDay === 0) {
                      findDay = 7
                    }
                    if (findDay === j + 1) {
                      dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                    }
                  }
                }
              }
              dateArr = dateArr.sort()
            }

            dateSet = dateArr[0]
            minDOBirth = dateArr[0]
          } else {
            minDOBirth = dateSet
          }
        } else {
          if (response?.brokerDayOfWeeks && response?.brokerDayOfWeeks.length !== 0 && !response?.isPostRecurring && !response?.isRecurring) {
            if (response.brokerDayOfWeeks.length !== 0) {
              for (let i = 0; i < response.brokerDayOfWeeks.length; i++) {
                let weekDays = [
                  'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
                ];

                let curDate = new Date(plusTwo);
                let nextDaysDate = new Date(plusTwo)

                let to = curDate.setDate(curDate.getDate() + 7);
                for (let j = 0; j < weekDays.length; j++) {
                  if (weekDays[j] === response.brokerDayOfWeeks[i]) {
                    for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                      let findDay = new Date(k).getDay()
                      if (findDay === 0) {
                        findDay = 7
                      }
                      if (findDay === j + 1) {
                        dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                      }
                    }
                  }
                }
                dateArr = dateArr.sort()
              }
            }
            dateSet = dateArr[0]
            minDOBirth = dateArr[0]
          } else {
            if (response && response.dayOfWeeks && response.dayOfWeeks.length !== 0) {
              for (let i = 0; i < response.dayOfWeeks.length; i++) {
                let weekDays = [
                  'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
                ];

                let curDate = new Date(plusTwo);
                let nextDaysDate = new Date(plusTwo)

                let to = curDate.setDate(curDate.getDate() + 7);
                for (let j = 0; j < weekDays.length; j++) {
                  if (weekDays[j] === response.dayOfWeeks[i]) {
                    for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
                      let findDay = new Date(k).getDay()
                      if (findDay === 0) {
                        findDay = 7
                      }
                      if (findDay === j + 1) {
                        dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                      }
                    }
                  }
                }
                dateArr = dateArr.sort()
              }

              dateSet = dateArr[0]
              minDOBirth = dateArr[0]
            } else {
              minDOBirth = dateSet
            }
          }
        }
      }
      // else{
      //   if (response?.brokerDayOfWeeks && !response?.isPostRecurring && !response?.isRecurring) {
      //     if (response.brokerDayOfWeeks.length !== 0) {
      //       for (let i = 0; i < response.brokerDayOfWeeks.length; i++) {
      //         let weekDays = [
      //           'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
      //         ];

      //         let curDate = new Date(plusTwo);
      //         let nextDaysDate = new Date(plusTwo)

      //         let to = curDate.setDate(curDate.getDate() + 7);
      //         for (let j = 0; j < weekDays.length; j++) {
      //           if (weekDays[j] === response.brokerDayOfWeeks[i]) {
      //             for (let k = nextDaysDate; k < new Date(to); k.setDate(k.getDate() + 1)) {
      //               let findDay = new Date(k).getDay()
      //               if (findDay === 0) {
      //                 findDay = 7
      //               }
      //               if (findDay === j + 1) {
      //                 dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
      //               }
      //             }
      //           }
      //         }
      //         dateArr = dateArr.sort()
      //       }
      //     }
      //     dateSet = dateArr[0]
      //     minDOBirth = dateArr[0]
      //   }
      // }

      if (type === "makeOffer") {
        minDOBirth = dateSet
        let maxdate = mindate.setDate(mindate.getDate() + 12);
        maxDOBirth = maxdate;
      } else {
        minDOBirth = dateSet
        let maxdate = mindate.setDate(mindate.getDate() + 7);
        maxDOBirth = maxdate;
      }
    } else {
      if (type === "makeOffer") {
        // if(response?.requestedDate){
        //   dateSet = new Date(response?.requestedDate * 1000)
        //   minDOBirth = new Date(response?.requestedDate * 1000)
        //   maxDOBirth = currentdate.setDate(currentdate.getDate() + 7);  
        // }else{
        dateSet = new Date(new Date().setHours(new Date().getHours() + 24))
        minDOBirth = new Date(new Date().setHours(new Date().getHours() + 24))
        maxDOBirth = currentdate.setDate(currentdate.getDate() + 12);
        // }

      } else {
        dateSet = new Date(new Date().setHours(new Date().getHours() + 24))
        minDOBirth = new Date(new Date().setHours(new Date().getHours() + 24))
        maxDOBirth = currentdate.setDate(currentdate.getDate() + 7);
      }
    }
  } else if (name === "taxExemptionExpireDate" || name === "editTaxExemptionExpireDate") {
    const currentdate = new Date();
    let plusTwo = dateSet
    if (name === "taxExemptionExpireDate") {
      if (response.userDetails.taxExemptionExpireDate) {
      }
    } else {
      plusTwo = new Date(selectedEditDate)
    }

    dateSet = new Date(plusTwo)
    if (dateSet <= new Date(currentdate)) {
      minDOBirth = new Date(dateSet)
    } else {
      minDOBirth = new Date(currentdate)
    }

    const maxdate = new Date(currentdate.setYear(currentdate.getFullYear() + 1));
    maxDOBirth = maxdate;
  } else if (name === 'recurranceStartDate') {
    if (editResponse && editResponse.requestDeliveryDate) {
      let plusTwo = moment(new Date().setDate(new Date(editResponse.requestDeliveryDate).getDate()))
      dateSet = new Date(plusTwo)
    } else {
      if (selectedDate) {
        let date = new Date(selectedDate);
        // let plusOne = date.setDate(date.getDate() + 1);
        dateSet = new Date(date)
      } else {
        let date = new Date();
        let plusTwo = date.setDate(date.getDate() + 4);
        dateSet = new Date(plusTwo)
      }
      if (type = 'recOrderPost') {
        let date = new Date();
        let plusTwo = date.setDate(date.getDate() + 7);
        maxDOBirth = new Date(plusTwo);
      }
    }

    const currentdate = new Date();
    minDOBirth = currentdate.setDate(currentdate.getDate() + 1);
    const maxdate = new Date(currentdate.setYear(currentdate.getFullYear() + 1));

    maxDOBirth = maxdate;
  } else if (name === "recurranceEndDate") {
    let minDateVal

    if (selectedDate) {
      // let date = new Date(selectedDate);
      // let setDate = date.setDate(date.getDate());
      // let getDate = new Date(setDate)
      // let plusTwo = getDate.setMonth(getDate.getMonth() + 1);
      // dateSet = new Date(plusTwo)
      dateSet = new Date(selectedDate);
      const currentdate = new Date();
      minDateVal = new Date(currentdate)
    } else {
      let date = new Date();
      let setDate = date.setDate(date.getDate() + 4);
      let getDate = new Date(setDate)
      let plusTwo = getDate.setMonth(getDate.getMonth() + 1);
      dateSet = new Date(plusTwo)
      const currentdate = new Date();
      minDateVal = new Date(currentdate)
    }
    const currentdate = new Date();

    let maxdate
    if (type === 'recOrderPost') {
      let nextTenWeeks = currentdate.setDate(currentdate.getDate() + 7 * 10)
      maxdate = new Date(nextTenWeeks)
    }else{
      let nextSixMonths = currentdate.setMonth(currentdate.getMonth() + 6)
      maxdate = new Date(nextSixMonths)      
    }

    const date = new Date();
    minDOBirth = minDate;
    maxDOBirth = maxdate;
  } else if (name === "repostDate") {
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 3)
    dateSet = new Date(plusTwo)

    let mindate = new Date(plusTwo);
    const currentdate = new Date();
    minDOBirth = new Date(currentdate);
    const maxdate = mindate.setDate(mindate.getDate() + 7);
    maxDOBirth = maxdate;
  } else if (name === 'repostBidCloseTime') {
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 1)
    minDOBirth = new Date()
    dateSet = new Date(plusTwo)
    let mindate = new Date(minDOBirth);
    const currentdate = new Date();
    const maxdate = mindate.setDate(mindate.getDate() + 4);
    maxDOBirth = maxdate;

  } else if (name === "cancelDate") {
    let date = new Date();
    let plusTwo = date.setDate(date.getDate() + 7);
    maxDOBirth = new Date(plusTwo);
    dateSet = new Date();
  } else if (name === 'recStartDateTemp' || name === 'recEndDateTemp') {
    let currentDate = new Date();
    minDOBirth = moment(currentDate.setDate(currentDate.getDate() + 1)).format('MM/DD/YYYY');
    maxDOBirth = moment(currentDate.setDate(currentDate.getDate() + 365)).format('MM/DD/YYYY');
    dateSet = selectedDate
  } else if (editedValuePrefill && name === "commissionStartDate") {
    dateSet = editedValuePrefill
    maxDOBirth = editedValuePrefill
  } else if (!editedValuePrefill && name === "commissionStartDate") {
    let minDate = new Date().setDate(new Date().getDate() - 31)
    minDOBirth = minDate
    maxDOBirth = max
  }
  else if (name === "commissionEndDate") {
    if (editedValuePrefill) {
      dateSet = editedValuePrefill
      minDOBirth = editedValuePrefill
      const currentdate = new Date();
      let nextTenWeeks = currentdate.setMonth(currentdate.getMonth() + 12)
      maxDOBirth = new Date(nextTenWeeks);
    } else {
      dateSet = moment(new Date().setMonth(new Date().getMonth() + 1)).format("MM/DD/YYYY");
      const currentdate = new Date();
      let nextTenWeeks = currentdate.setMonth(currentdate.getMonth() + 12)
      minDOBirth = min
      maxDOBirth = new Date(nextTenWeeks);
    }
  } else {
    const currentdate = new Date();
    const maxdate = new Date(currentdate.setYear(currentdate.getFullYear() + 1));
    minDOBirth = dateSet;

    if (type === "createOrder") {
      let plusTwentyTwo = new Date().setDate(new Date().getDate() + 22);
      let currentDate = new Date();
      minDOBirth = currentDate.setDate(currentDate.getDate() + 1);

      const date = new Date();
      let plusFourDays = date.setDate(date.getDate() + 4);
      dateSet = new Date(plusFourDays)

      maxDOBirth = plusTwentyTwo
    } else {
      maxDOBirth = maxdate;
    }
  }

  if (name === "orderDeliveryDate") {
    dateSet = new Date();
    if (uploadType === 'reUpload' && selectedDate) {
      dateSet = moment(selectedDate).format("MM/DD/YYYY")
    }
    maxDOBirth = dateSet;
    let minDate = new Date().setDate(new Date().getDate() - 31)
    minDOBirth = minDate
  }

  if (name === "rateStartDate") {
    dateSet = new Date();
    dateSet = moment(dateSet).format("MM/DD/YYYY")

    let minDate = new Date(dateSet) //new Date().setDate(new Date().getDate() - 31)
    minDOBirth = minDate

    const currentdate = new Date();
    let nextTenWeeks = currentdate.setMonth(currentdate.getMonth() + 1)
    maxDOBirth = new Date(nextTenWeeks);
    if(max){
      maxDOBirth = moment(max).format("MM/DD/YYYY")
    }

    if (editedValuePrefill) {
      dateSet = editResponse.rateStartDate
      maxDOBirth = editResponse.rateExpDate
    }
  }
  if (name === "rateExpDate") {
    dateSet = new Date();
    dateSet = moment(dateSet.setMonth(dateSet.getMonth() + 12)).format("MM/DD/YYYY")

    let minDate = new Date().setDate(new Date().getDate() + 1)
    minDOBirth = minDate
    if(min){
      minDOBirth = moment(min).format("MM/DD/YYYY")
    }

    const currentdate = new Date();
    let maxDOBirthValue = currentdate.setMonth(currentdate.getMonth() + 24)
    maxDOBirth = new Date(maxDOBirthValue);
    maxDOBirth = moment(maxDOBirth).format("MM/DD/YYYY")
    // const currentdate = new Date(dateSet);
    // let nextTenWeeks = currentdate.setMonth(currentdate.getMonth() + 1)
    // maxDOBirth = new Date(nextTenWeeks);
    if (editedValuePrefill) {
      dateSet = editResponse.rateExpDate
      minDOBirth = editResponse.rateStartDate
    }
  }

  if (name === 'deliveryOrPickUpDateGetQuote') {
    maxDOBirth = moment().add(1, 'months');
  }

  if (name === 'checkOutDateBuyerOffer') {
    minDOBirth = new Date(minDate);
    maxDOBirth = new Date(minDOBirth);
    if(otherProps.checkoutPageType === 'buyerInvCheckoutmakeOffer') maxDOBirth.setDate(minDOBirth.getDate() + 10)
    else maxDOBirth.setDate(minDOBirth.getDate() + 7)    
  } else if (name === 'checkOutAltDateBuyerOffer') {
    minDOBirth = minDate
    maxDOBirth = new Date().setDate(new Date().getDate() + 13)
  }
  
  const handleDateChange = (name, setFieldValue, setFieldError, date) => {
    setDateFlag(true)
    onChange(date)
    if (name === 'dob') {
      let test = differenceInYears(new Date(), new Date(date)) >= 18
      if (!test) {
        setFieldError(name, 'Age must be 18 or older.');
        setFieldValue(name, moment(new Date()).format(BIDFORMAT))
      } else {
        let getYear = new Date(date).getFullYear()

        if (getYear.toString() < '1900') {
          setFieldError(name, "Age must be 18 or older");
          setFieldValue(name, moment(new Date()).format(BIDFORMAT))
        }
        else {
          setFieldValue(name, moment(date).format(BIDFORMAT));
        }

      }
    } else if (name === "requestDeliveryDate" || name === "bidCloseTime" || name?.includes('checkOut')) {
      setFieldValue(name, moment(date).format(FORMAT));
    } else {
      setFieldValue(name, moment(date).format(BIDFORMAT));
      if (name === "recurranceStartDate" || name === "recurranceEndDate" || name === "orderDeliveryDate") callBackFun(moment(date).format(BIDFORMAT))
    }
  };
  var endDate = new Date();
  var numberOfDaysToAdd = 13;

  const daysHighlighted = new Array(numberOfDaysToAdd).fill(endDate);

  const disabledDays = (date) => {
    const myDates = dateArr
    if (response && response?.brokerDayOfWeeks && response?.brokerDayOfWeeks?.length !== 0 && type === "DatesDisabled") {
      return !myDates.map((myDate) => new Date(myDate).getTime()).includes(date.getTime());
    }

    if (response && response?.dayOfWeeks && response?.dayOfWeeks.length !== 0 && response?.brokerDayOfWeeks?.length === 0 && type === "DatesDisabled") {
      const myDates = dateArr
      return !myDates.map((myDate) => new Date(myDate).getTime()).includes(date.getTime());
    }
    if (response && response?.defaultProfile && response?.defaultProfile?.dayOfWeeks?.length !== 0 && type === "ReschduleDatesDisabled") {
      const myDates = dateArr
      return !myDates.map((myDate) => new Date(myDate).getTime()).includes(date.getTime());
    }
    if (type === "claimDatesDisabled") {
      if (response && response?.order?.defaultProfile?.dayOfWeeks) {
        const myDates = dateArr
        return !myDates.map((myDate) => new Date(myDate).getTime()).includes(date.getTime());
      }
    }

    if (nonDisabledDaysList) {
      const allowedWeekdays = nonDisabledDaysList
      const dayOfWeek = date.toLocaleString("en-US", { weekday: "long" }).toUpperCase();
      return !allowedWeekdays.includes(dayOfWeek);
    }
  };

  const [value, onChange] = useState(dateSet);

  return (
    <div>
      <Field name={name}>
        {({ field, form, meta }) => {
          return (
            <>
              <div className='custom-date-piker'>
                <div
                  className={`file-input-wrapper ${meta.touched && meta.error ? 'error' : ''
                    }`}
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disabled={disabled ? disabled : false}
                      minDate={minDOBirth}
                      maxDate={maxDOBirth}
                      // allowKeyboardControl={true}
                      shouldDisableDate={(date) => disabledDays(date)}
                      name={name}
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      value={type === "createOrder" ? value :
                        (name === 'requestDeliveryDate' || name === "bidCloseTime" || name === "checkOutDateBuyerOffer" || name === "checkOutAltDateBuyerOffer") ? selectedDate :
                          (name === "recurranceStartDate" || name === "recurranceEndDate") && getClearDateFlag ? dateSet :
                            name === "deliveryDateCheckout" && !dateFlag ? dateSet : value}
                      highlightDates={[
                        {
                          "highlighted-class": daysHighlighted.map((day, index) => {
                            day.setDate(day.getDate() + index)
                            return new Date(day)
                          }
                          )
                        }
                      ]}
                      onChange={(date) => {
                        if (name === 'recurranceStartDate') {
                          callBackFun(date)
                        }
                        handleDateChange(name, form.setFieldValue, form.setFieldError, date)
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      InputProps={{ readOnly: type === "DatesDisabled" ? true : false }}
                    />

                  </MuiPickersUtilsProvider>

                </div>
              </div>
              {meta.error && <p name={name + 'Error'} className="error-message">{meta.error}</p>}
            </>
          );
        }}
      </Field>
    </div>
  );
};
